import { Observable, observe, Scope } from 'wdc-cube'
import { AnaliseRow } from '../analise.types'
import { RegraRow } from '../regra/regra.types'
import { WaitingScope } from 'src/components/waiting/waiting.scopes'

@Observable
export class AnaliseFormScope extends Scope {
    @observe() waiting?: WaitingScope
    @observe() saving = false

    @observe() idSelected = 0

    @observe() tipo = 'CEDENTE_SACADO'
    @observe() nome = ''
    @observe() status = 'ATIVO'
    @observe() riscoBorderoDe = 0
    @observe() riscoBorderoAte = 0
    @observe() riscoCarteiraDe = 0
    @observe() riscoCarteiraAte = 0
    @observe() pararAoBloquear = false
    @observe() obrigatorioNfe = false
    @observe() aplicarPf = false
    @observe() modeloSerasa = 'RELATO_QSA'
    @observe() consultarSerasaDias = 0
    @observe() naoRealizarNovaConsulta = false
    @observe() consultarSituacaoPfDias = 0
    @observe() naoRealizarNovaConsultaSituacaoPf = false
    @observe() consultarProtestosDias = 0
    @observe() naoRealizarNovaConsultaProtestos = false
    @observe() operacaoEmpresa = 'TODOS'
    @observe() regras = [] as RegraRow[]
    @observe() idRegraSelecionada = 0

    onSave = async (): Promise<AnaliseRow | undefined> => undefined
    onClose = Scope.ASYNC_ACTION
    onAddRegra = Scope.ASYNC_ACTION
    onEditRegra = Scope.ASYNC_ACTION
    onDeleteRegra = Scope.ASYNC_ACTION
}

export default AnaliseFormScope
